import {useEffect} from "react";
import {useLocation} from "react-router-dom";

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

export default function GA4PageViews() {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;

        window.gtag("config", "G-9QMJ3WFP2T", {
            page_path: location.pathname + location.search,
        });
    }, [location]);

    return null;
}